import { type FAQ } from "../../../../Components/FAQ/FAQAccordion";

const featureName = "Kubernetes Lens";

export const fsk8sFaqs: FAQ[] = [
  {
    question: `What are ${featureName} and Flexsave for Kubernetes? How are they different?`,
    answer: `${featureName} is an out-of-the-box visibility solution that helps monitor and track Kubernetes costs and resource utilization.\n Flexsave for Kubernetes is a separate automation solution powered by PerfectScale; it eliminates the manual effort of optimization by autonomously rightsizing your Kubernetes clusters for the best possible cost and performance.`,
  },
  {
    question: "Is Flexsave for Kubernetes included in my DoiT Cloud Intelligence plan?",
    answer: `No, while ${featureName} is included in our Enhanced and Enterprise plans, Flexsave for Kubernetes is an add-on solution that gets priced based on the size of your environment.`,
  },
  {
    question:
      "If I have subscriptions to both DoiT Cloud Intelligence and Flexsave for Kubernetes, will I have separate user interfaces and logins for each one?",
    answer:
      "Yes, each platform will maintain its own UI and login for the time being, so customers with subscriptions to both platforms will login separately.",
  },
  {
    question: "Do I have to install an agent?",
    answer:
      "Yes, both Kubernetes solutions run off of the same agent. Detailed instructions for doing so can be found in our Help documentation [link doesnt exist yet]",
  },
  {
    question: "What permissions are required to start using this feature?",
    answer: "[Answer TBD]",
  },
];
